/*!
 * Copyright (c) 2018-2019 Digital Bazaar, Inc. All rights reserved.
 */
'use strict';

var _defineProperty = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/helpers/defineProperty");

var _regeneratorRuntime = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/helpers/inherits");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var env = require('./env');

var forge = require('node-forge');

var sha256 = forge.md.sha256,
    _forge$pki = forge.pki,
    getPublicKeyFingerprint = _forge$pki.getPublicKeyFingerprint,
    publicKeyFromPem = _forge$pki.publicKeyFromPem,
    _forge$util$binary = forge.util.binary,
    base58 = _forge$util$binary.base58,
    raw = _forge$util$binary.raw;

var LDKeyPair = require('./LDKeyPair');
/**
 * @constant
 * @type {number}
 * @default
 */


var DEFAULT_RSA_KEY_BITS = 2048;
/**
 * @constant
 * @type {number}
 * @default
 */

var DEFAULT_RSA_EXPONENT = 0x10001;

var RSAKeyPair =
/*#__PURE__*/
function (_LDKeyPair) {
  _inherits(RSAKeyPair, _LDKeyPair);

  /* eslint-disable max-len */

  /**
   * An implementation of
   * [RSA encryption]{@link https://simple.wikipedia.org/wiki/RSA_algorithm}
   * for
   * [jsonld-signatures]{@link https://github.com/digitalbazaar/jsonld-signatures}.
   * @example
   * > const options = {
   *    privateKeyPem: 'testPrivateKey',
   *    publicKeyPem: 'testPublicKey'
   *  };
   * > const RSAKey = new RSAKeyPair(options);
   * @param {KeyPairOptions} options - Keys must be in RSA format other
   * options must follow [KeyPairOptions]{@link ./index.md#KeyPairOptions}.
   * @param {string} options.publicKeyPem - Public Key for Signatures.
   * @param {string} options.privateKeyPem - Your Confidential key for signing.
   */

  /* eslint-enable */
  function RSAKeyPair() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, RSAKeyPair);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RSAKeyPair).call(this, options));
    _this.type = 'RsaVerificationKey2018';
    _this.privateKeyPem = options.privateKeyPem;
    _this.publicKeyPem = options.publicKeyPem;

    _this.validateKeyParams(); // validate keyBits and exponent


    return _this;
  }
  /**
   * Returns the public key.
   * @implements {LDKeyPair#publicKey}
   * @readonly
   *
   * @returns {string} The public key.
   * @see [publicKey]{@link ./LDKeyPair.md#publicKey}
   */


  _createClass(RSAKeyPair, [{
    key: "validateKeyParams",

    /**
     * Validates this key.
     * @example
     * > rsaKeyPair.validateKeyParams();
     * undefined
     *
     * @returns {undefined} If it does not throw then the key is valid.
     * @throws Invalid RSA keyBit length
     * @throws Invalid RSA exponent
     */
    value: function validateKeyParams() {
      if (this.publicKeyPem) {
        var publicKey = forge.pki.publicKeyFromPem(this.publicKeyPem);
        var keyBits = publicKey.n.bitLength();

        if (keyBits !== DEFAULT_RSA_KEY_BITS) {
          throw new Error("Invalid RSA keyBit length ".concat(JSON.stringify(keyBits)) + " required value is ".concat(DEFAULT_RSA_KEY_BITS));
        }

        if (publicKey.e.toString(10) !== '65537') {
          throw new Error("Invalid RSA exponent ".concat(JSON.stringify(publicKey.e.toString(10))) + ' required value is 65537}');
        }
      }

      if (this.privateKeyPem) {
        var privateKey = forge.pki.privateKeyFromPem(this.privateKeyPem);

        var _keyBits = privateKey.n.bitLength();

        if (_keyBits !== DEFAULT_RSA_KEY_BITS) {
          throw new Error("Invalid RSA keyBit length ".concat(JSON.stringify(_keyBits)) + " required value is ".concat(DEFAULT_RSA_KEY_BITS));
        }

        if (privateKey.e.toString(10) !== '65537') {
          throw new Error("Invalid RSA exponent ".concat(JSON.stringify(privateKey.e.toString(10))) + ' required value is 65537}');
        }
      }
    }
    /**
     * Adds this KeyPair's publicKeyPem to a public node.
     * @example
     * > rsaKeyPair.addEncodedPublicKey({id: 'testnode'});
     * { publicKeyPem: 'testPublicKey' }
     * @param {KeyPairOptions} publicKeyNode - A Node with out a publicKeyPem set.
     *
     * @returns {KeyPairOptions} A public node with a publicKeyPem set.
     * @see [KeyPairOptions]{@link ./index.md#KeyPairOptions}
     */

  }, {
    key: "addEncodedPublicKey",
    value: function addEncodedPublicKey(publicKeyNode) {
      publicKeyNode.publicKeyPem = this.publicKeyPem;
      return publicKeyNode;
    }
    /**
     * Adds this KeyPair's privateKeyPem to a public node.
     * @example
     * > rsaKeyPair.addEncryptedPrivateKey({id: 'testnode'});
     * { privateKeyPem: 'testPrivateKey' }
     * @param {KeyPairOptions} keyNode - A Node with out a publicKeyPem set.
     *
     * @returns {KeyPairOptions} A public node with a privateKeyPem set.
     * @see [KeyPairOptions]{@link ./index.md#KeyPairOptions}
     */

  }, {
    key: "addEncryptedPrivateKey",
    value: function () {
      var _addEncryptedPrivateKey = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(keyNode) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.passphrase !== null) {
                  keyNode.privateKeyPem = forge.pki.encryptRsaPrivateKey(forge.pki.privateKeyFromPem(this.privateKeyPem), this.passphrase, {
                    algorithm: 'aes256'
                  });
                } else {
                  // no passphrase, do not encrypt private key
                  keyNode.privateKeyPem = this.privateKeyPem;
                }

                return _context.abrupt("return", keyNode);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function addEncryptedPrivateKey(_x) {
        return _addEncryptedPrivateKey.apply(this, arguments);
      }

      return addEncryptedPrivateKey;
    }()
    /**
     * Generates and returns a multiformats
     * encoded RSA public key fingerprint (for use with cryptonyms, for example).
     * @example
     * > rsaKeyPair.fingerprint();
     * 3423dfdsf3432sdfdsds
     *
     * @returns {string} An RSA fingerprint.
     */

  }, {
    key: "fingerprint",
    value: function fingerprint() {
      var buffer = forge.util.createBuffer(); // use SubjectPublicKeyInfo fingerprint

      var fingerprintBuffer = forge.pki.getPublicKeyFingerprint(forge.pki.publicKeyFromPem(this.publicKeyPem), {
        md: sha256.create()
      }); // RSA cryptonyms are multiformats encoded values, specifically they are:
      // (multicodec RSA SPKI-based public key 0x5d + sha2-256 0x12 +
      // 32 byte value 0x20)

      buffer.putBytes(forge.util.hexToBytes('5d1220'));
      buffer.putBytes(fingerprintBuffer.bytes()); // prefix with `z` to indicate multi-base base58btc encoding

      return "z".concat(base58.encode(buffer));
    }
    /*
     * Tests whether the fingerprint
     * was generated from a given key pair.
     * @example
     * > rsaKeyPair.verifyFingerprint('zdsfdsfsdfdsfsd34234');
     * {valid: true}
     * @param {string} fingerprint - An RSA fingerprint for a key.
     *
     * @returns {boolean} True if the fingerprint is verified.
     */

  }, {
    key: "verifyFingerprint",
    value: function verifyFingerprint(fingerprint) {
      // fingerprint should have `z` prefix indicating
      // that it's multi-base encoded
      if (!(typeof fingerprint === 'string' && fingerprint[0] === 'z')) {
        return {
          error: new Error('`fingerprint` must be a multibase encoded string.'),
          valid: false
        };
      } // base58.decode returns Buffer(nodejs) or Uint8Array


      var fingerprintBuffer = base58.decode(fingerprint.slice(1)); // keyFingerprintBuffer is a forge ByteStringBuffer

      var keyFingerprintBuffer = getPublicKeyFingerprint(publicKeyFromPem(this.publicKeyPem), {
        md: sha256.create()
      }); // validate the first three multicodec bytes 0x5d1220

      var valid = fingerprintBuffer.slice(0, 3).toString('hex') === '5d1220' && keyFingerprintBuffer.toHex() === fingerprintBuffer.slice(3).toString('hex');

      if (!valid) {
        return {
          error: new Error('The fingerprint does not match the public key.'),
          valid: false
        };
      }

      return {
        valid: valid
      };
    }
    /* eslint-disable max-len */

    /**
     * Returns a signer object with an async sign function for use by
     * [jsonld-signatures]{@link https://github.com/digitalbazaar/jsonld-signatures}
     * to sign content in a signature.
     * @example
     * > const signer = rsaKeyPair.signer();
     * > signer.sign({data});
     *
     * @returns {{sign: Function}} An RSA Signer Function for a single key.
     * for a single Private Key.
     */

    /* eslint-enable */

  }, {
    key: "signer",
    value: function signer() {
      return rsaSignerFactory(this);
    }
    /* eslint-disable max-len */

    /**
     * Returns a verifier object with an async
     * function verify for use with
     * [jsonld-signatures]{@link https://github.com/digitalbazaar/jsonld-signatures}.
     * @example
     * > const verifier = rsaKeyPair.verifier();
     * > const valid = await verifier.verify({data, signature});
     *
     * @returns {{verify: Function}} An RSA Verifier Function for a single key.
     */

    /* eslint-enable */

  }, {
    key: "verifier",
    value: function verifier() {
      return rsaVerifierFactory(this);
    }
  }, {
    key: "publicKey",
    get: function get() {
      return this.publicKeyPem;
    }
    /**
     * Returns the private key.
     * @implements {LDKeyPair#privateKey}
     * @readonly
     *
     * @returns {string} The private key.
     * @see [privateKey]{@link ./LDKeyPair.md#privateKey}
     */

  }, {
    key: "privateKey",
    get: function get() {
      return this.privateKeyPem;
    }
    /**
     * Generates an RSA KeyPair using the RSA Defaults.
     * @example
     * > const keyPair = await RSAKeyPair.generate();
     * > keyPair
     * RSAKeyPair { ...
     * @param {KeyPairOptions} [options={}] - See LDKeyPair
     * docstring for full list.
     *
     * @returns {Promise<RSAKeyPair>} A Default encrypted RSA KeyPair.
     * @see [KeyPairOptions]{@link ./index.md#KeyPairOptions}
     */

  }], [{
    key: "generate",
    value: function () {
      var _generate = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var options,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
                return _context2.abrupt("return", new Promise(function (resolve, reject) {
                  forge.pki.rsa.generateKeyPair({
                    bits: DEFAULT_RSA_KEY_BITS,
                    e: DEFAULT_RSA_EXPONENT,
                    workers: -1
                  }, function (err, keyPair) {
                    if (err) {
                      return reject(err);
                    }

                    resolve(new RSAKeyPair(_objectSpread({
                      publicKeyPem: forge.pki.publicKeyToPem(keyPair.publicKey),
                      privateKeyPem: forge.pki.privateKeyToPem(keyPair.privateKey)
                    }, options)));
                  });
                }));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function generate() {
        return _generate.apply(this, arguments);
      }

      return generate;
    }()
    /**
     * Creates a RSA Key Pair from an existing private key.
     * @example
     * > const options = {
     *    privateKeyPem: 'testkeypem'
     *  };
     * > const key = await RSAKeyPair.from(options);
     * @param {Object} options - Contains a private key.
     * @param {Object} [options.privateKey] - A private key.
     * @param {string} [options.privateKeyPem] - An RSA Private key.
     *
     * @returns {RSAKeyPair} An RSA Key Pair.
     */

  }, {
    key: "from",
    value: function () {
      var _from = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(options) {
        var privateKeyPem, keys;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                privateKeyPem = options.privateKeyPem || // legacy privateDidDoc format
                options.privateKeyPem && options.privateKey.privateKeyPem;
                keys = new RSAKeyPair(_objectSpread({
                  publicKey: options.publicKeyPem,
                  privateKeyPem: privateKeyPem,
                  type: options.type || options.keyType
                }, options));
                return _context3.abrupt("return", keys);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function from(_x2) {
        return _from.apply(this, arguments);
      }

      return from;
    }()
  }]);

  return RSAKeyPair;
}(LDKeyPair);
/**
 * @ignore
 * Returns an object with an async sign function.
 * The sign function is bound to the KeyPair
 * and then returned by the KeyPair's signer method.
 * @example
 * > const factory = rsaSignerFactory(rsaKeyPair);
 * > const bytes = await factory.sign({data});
 * @param {RSAKeyPair} key - They key this factory will verify for.
 *
 * @returns {{sign: Function}} An RSA Verifier Function for a single key.
 */


function rsaSignerFactory(key) {
  if (!key.privateKeyPem) {
    return {
      sign: function () {
        var _sign = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee4() {
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  throw new Error('No private key to sign with.');

                case 1:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));

        function sign() {
          return _sign.apply(this, arguments);
        }

        return sign;
      }()
    };
  } // Note: Per rfc7518, the digest algorithm for PS256 is SHA-256,
  // https://tools.ietf.org/html/rfc7518
  // sign data using RSASSA-PSS where PSS uses a SHA-256 hash,
  // a SHA-256 based masking function MGF1, and a 32 byte salt to match
  // the hash size


  if (env.nodejs) {
    // node.js 8+
    var crypto = require('crypto');

    if ('RSA_PKCS1_PSS_PADDING' in crypto.constants) {
      return {
        sign: function () {
          var _sign2 = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee5(_ref) {
            var data, signer, buffer;
            return _regeneratorRuntime.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    data = _ref.data;
                    signer = crypto.createSign('RSA-SHA256');
                    signer.update(Buffer.from(data.buffer, data.byteOffset, data.length));
                    buffer = signer.sign({
                      key: key.privateKeyPem,
                      padding: crypto.constants.RSA_PKCS1_PSS_PADDING,
                      saltLength: crypto.constants.RSA_PSS_SALTLEN_DIGEST
                    });
                    return _context5.abrupt("return", new Uint8Array(buffer.buffer, buffer.byteOffset, buffer.length));

                  case 5:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee5);
          }));

          function sign(_x3) {
            return _sign2.apply(this, arguments);
          }

          return sign;
        }()
      };
    }
  } // browser or other environment (including node 6.x)


  var privateKey = forge.pki.privateKeyFromPem(key.privateKeyPem);
  return {
    sign: function () {
      var _sign3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(_ref2) {
        var data, pss, md, binaryString;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                data = _ref2.data;
                pss = createPss();
                md = sha256.create();
                md.update(raw.encode(data), 'binary');
                binaryString = privateKey.sign(md, pss);
                return _context6.abrupt("return", raw.decode(binaryString));

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function sign(_x4) {
        return _sign3.apply(this, arguments);
      }

      return sign;
    }()
  };
}
/**
 * @ignore
 * Returns an object with an async verify function.
 * The verify function is bound to the KeyPair
 * and then returned by the KeyPair's verifier method.
 * @example
 * > const verifier = rsaVerifierFactory(rsaKeyPair);
 * > verifier.verify({data, signature});
 * false
 * @param {RSAKeyPair} key - An RSAKeyPair.
 *
 * @returns {Function} An RSA Verifier for the key pair passed in.
 */


function rsaVerifierFactory(key) {
  if (env.nodejs) {
    // node.js 8+
    var crypto = require('crypto');

    if ('RSA_PKCS1_PSS_PADDING' in crypto.constants) {
      return {
        verify: function () {
          var _verify = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee7(_ref3) {
            var data, signature, verifier;
            return _regeneratorRuntime.wrap(function _callee7$(_context7) {
              while (1) {
                switch (_context7.prev = _context7.next) {
                  case 0:
                    data = _ref3.data, signature = _ref3.signature;
                    verifier = crypto.createVerify('RSA-SHA256');
                    verifier.update(Buffer.from(data.buffer, data.byteOffset, data.length));
                    return _context7.abrupt("return", verifier.verify({
                      key: key.publicKeyPem,
                      padding: crypto.constants.RSA_PKCS1_PSS_PADDING,
                      saltLength: crypto.constants.RSA_PSS_SALTLEN_DIGEST
                    }, Buffer.from(signature.buffer, signature.byteOffset, signature.length)));

                  case 4:
                  case "end":
                    return _context7.stop();
                }
              }
            }, _callee7);
          }));

          function verify(_x5) {
            return _verify.apply(this, arguments);
          }

          return verify;
        }()
      };
    }
  } // browser or other environment (including node 6.x)


  var publicKey = publicKeyFromPem(key.publicKeyPem);
  return {
    verify: function () {
      var _verify2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8(_ref4) {
        var data, signature, pss, md;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                data = _ref4.data, signature = _ref4.signature;
                pss = createPss();
                md = sha256.create();
                md.update(raw.encode(data), 'binary');
                _context8.prev = 4;
                return _context8.abrupt("return", publicKey.verify(md.digest().bytes(), raw.encode(signature), pss));

              case 8:
                _context8.prev = 8;
                _context8.t0 = _context8["catch"](4);
                return _context8.abrupt("return", false);

              case 11:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, null, [[4, 8]]);
      }));

      function verify(_x6) {
        return _verify2.apply(this, arguments);
      }

      return verify;
    }()
  };
}
/**
 * @ignore
 * creates an RSA PSS used in signatures.
 * @example
 * > const pss = createPss();
 *
 * @returns {PSS} A PSS object.
 * @see [PSS]{@link ./index.md#PSS}
 */


function createPss() {
  var md = sha256.create();
  return forge.pss.create({
    md: md,
    mgf: forge.mgf.mgf1.create(sha256.create()),
    saltLength: md.digestLength
  });
}

module.exports = RSAKeyPair;